const header__container = {
  display: "flex",
  flexDirection: "row",
  width: "100%",
  justifyContent: "space-between",
  verticalAlign: "baseline",
  marginBottom: "15px",
};

const header__h1 = {
  paddingTop: "3px",
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: "150%",
  color: "rgba(0, 174, 239, 1)",
};

const create__invoice__btn = {
  borderRadius: "8px",
  marginRight: "10px",
  backgroundColor: "blue",
  height: "38px",
  color: "white",
  "&:hover": {
    backgroundColor: "blue",
  },
};

const create__invoice__btn__label = {
  fontSize: "12px",
  fontWeight: 400,
  paddingRight: "5px",
  marginLeft: "5px",
};

const search__btn = {
  backgroundColor: "blue",
  borderRadius: "0px 8px 8px 0px",
  height: "38px",
};

export {
  header__container,
  header__h1,
  create__invoice__btn,
  create__invoice__btn__label,
  search__btn,
};
